// Roku Ads pixel events. The base pixel (script + rkp('init', ...)) lives in public/index.html.
// These calls are no-ops until the base pixel loads.
import { useEffect } from "react";

export const rkpEvent = (name) => {
  try {
    if (window.rkp) window.rkp("event", name);
  } catch { /* pixel blocked */ }
};

// Fires the CONTACT event for any click on a tap-to-call link on the page.
export const useRokuContactOnCallLinks = () => {
  useEffect(() => {
    const onClick = (e) => {
      const a = e.target.closest && e.target.closest('a[href^="tel:"]');
      if (a) rkpEvent("CONTACT");
    };
    document.addEventListener("click", onClick);
    return () => document.removeEventListener("click", onClick);
  }, []);
};
